import React from 'react';

import styles from './index.less';

const Field = ({ label, value, ...rest }) => (
  <div className={styles.field} {...rest}>
    <span>{label}</span>
    <span>{value}</span>
  </div>
);

export default Field;



// WEBPACK FOOTER //
// /Users/jim/Documents/GitHub/ant-design-pro-site/scaffold/src/components/Charts/Field/index.js